export default "__VITE_ASSET__CqDP_Mnj__"